<script lang="ts" setup>
	/**
	 * Racine du back-office.
	 *
	 * Le menu est filtré par les droits via `useRouteGranted` : un agent
	 * d'exploitation ne voit pas les sections d'administration. Ce filtrage est
	 * ergonomique — l'API refuse de toute façon les appels non autorisés.
	 */
	import { computed, onMounted, ref } from 'vue';
	import { useRoute } from 'vue-router';
	import { useTokenStore, useUserStore } from '@common/index';
	import Notify from '@common/components/Notify.vue';
	import { realtime } from '@/plugins';
	import BoNavigation from '@/components/layout/BoNavigation.vue';

	const route = useRoute();
	const tokenStore = useTokenStore();
	const userStore = useUserStore();

	const booting = ref(true);
	const drawer = ref(true);

	const isLoginScreen = computed(() => route.name === 'login');
	const pageTitle = computed(() => (route.meta?.title as string) ?? '');

	onMounted(async () => {
		tokenStore.setup();
		await userStore.load();

		if (tokenStore.isAuthenticated) {
			realtime.connect();
		}
		booting.value = false;
	});
</script>

<template>
	<v-app theme="monacoLight">
		<div v-if="booting" class="d-flex align-center justify-center" style="height: 100vh">
			<v-progress-circular indeterminate color="primary" size="42" />
		</div>

		<template v-else-if="isLoginScreen">
			<v-main>
				<router-view />
			</v-main>
		</template>

		<template v-else>
			<BoNavigation v-model="drawer" />

			<v-app-bar flat color="surface" class="border-b">
				<v-app-bar-nav-icon @click="drawer = !drawer" />
				<v-app-bar-title>{{ pageTitle }}</v-app-bar-title>
			</v-app-bar>

			<v-main>
				<router-view />
			</v-main>
		</template>

		<Notify />
	</v-app>
</template>

<style lang="scss">
	.border-b {
		border-bottom: 1px solid rgb(var(--v-border-color));
	}
</style>
